import { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";

import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { FormLabel, FormSelect } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import FormGroup from "react-bootstrap/FormGroup";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import { renderOptions } from "../../../utils/OptionsUtils";
import SurveyUtils from "../../../utils/SurveyUtils";
import DatePickerComponent from "../../common/datePicker/DatePicker";

class DownloadPdfReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportType: "",
      targetCountry: null,
      targetRegion: null,
      dateFrom: null,
      dateTo: null,
      programInstance: props.selectedProgramInstance?.overview?.id,
      location: props.selectedLocation?.overview?.id,
      periodStart: props.periodStart && props.periodStartOptions.includes(Number(props.periodStart)) ? props.periodStart : null,
      periodEnd: props.periodEnd && props.periodEndOptions.includes(Number(props.periodEnd)) ? props.periodEnd : null,
      status: props.status ?? null,}
    this._downloadPdf = this._downloadPdf.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {
        startConversion,
        surveyTemplates,
        surveySubmissions,
        convertPDFsAndZip,
        removePDFConversionData,
        showDialog,
        endLoading,
        beginLoading,
        close,
        intl
    } = this.props;

    const startConversionJustBecameTrue =
        !prevProps.startConversion && startConversion;

    const templatesJustBecameAvailable =
        Object.keys(prevProps.surveyTemplates || {}).length === 0 &&
        Object.keys(surveyTemplates || {}).length > 0;

    const shouldStartConversion =
        startConversion &&
        Object.keys(surveyTemplates || {}).length > 0 &&
        (startConversionJustBecameTrue || templatesJustBecameAvailable);

    if (!shouldStartConversion) {
        return;
    }

    const pdfCount = surveySubmissions.results?.length ?? 0;

    if (pdfCount > 5) {
        endLoading();
        showDialog(
        "",
        () => {
            beginLoading();
            convertPDFsAndZip(this.state.reportType);
            close();
        },
        "dialog.respondents.overview.start.conversion.title",
        intl.formatMessage(
            { id: "dialog.respondents.overview.start.conversion.text" },
            { count: pdfCount }
        ),
        "dialog.leave.runner.overview",
        "dialog.dismiss",
        <FontAwesomeIcon icon={faExclamationTriangle} size="2x" />,
        () => removePDFConversionData()
        );
    } else {
        convertPDFsAndZip(this.state.reportType);
        close();
    }
  }

  render() {
    const {
      show,
      close,
      countryOptions,
      regionsOptions,
      periodStartOptions,
      periodEndOptions,
      statusOptions,
      selectedProgram,
      intl
    } = this.props;



    const programInstances = selectedProgram?.overview?.programInstances;
    const selectedProgramInstance = programInstances?.find(instance => instance.id === this.state.programInstance);
    const locationInstances = selectedProgramInstance?.projects;
    return (
      <Modal show={show} size="lg" enforceFocus autoFocus className="download-pdf-reports-dialog">
        <ModalHeader closeButton onClick={close}>
          <Modal.Title>
            <FormattedMessage id="respondents.overview.download.pdf.reports.title" />
          </Modal.Title>
        </ModalHeader>
        <Modal.Body>
          <FormGroup className="mb-3">
            <FormLabel>
              <FormattedMessage id="respondents.overview.instance" />
            </FormLabel>
            <FormSelect
              className="d-inline-flex"
              value={this.state.programInstance}
              onChange={(event) => {
                this.setState({programInstance: event.target.value, location: ""})
              }}
            >
              {programInstances && <>
                <option value="">
                  <FormattedMessage id={"user.surveyView.dropdown.choose"} />
                </option>
                {programInstances.map(programInstance => (
                  <option key={programInstance.id} value={programInstance.id}>
                    {programInstance.name}
                  </option>
                ))}
              </>}
            </FormSelect>
          </FormGroup>

          {locationInstances &&
            <FormGroup className="mb-3">
              <FormLabel>
              <FormattedMessage id="respondents.overview.location" />
            </FormLabel>
              <FormSelect
                className="d-inline-flex"
                onChange={(event) => this.setState({location: event.target.value})}
                value={this.state.location}
              >
                {locationInstances &&
                  <>
                    <option value="">
                      <FormattedMessage id={"user.surveyView.dropdown.choose"} />
                    </option>

                    {locationInstances.map(locationInstance => (
                      <option key={locationInstance.id} value={locationInstance.id}>
                        {locationInstance.name}
                      </option>
                    ))}
                  </>
                }
              </FormSelect>
            </FormGroup>
          }

          <FormGroup className="mb-3">
            <FormLabel>
              <FormattedMessage id="respondents.overview.reportPeriod" /> *
            </FormLabel>
            <FormSelect
              className="d-inline-flex"
              value={this.state.periodStart}
              required
              isInvalid={!this.state.periodStart}
              onChange={(event) =>
                this.setState({periodStart: event.target.value})
              }
            >
              {renderOptions(
                periodStartOptions,
                "survey.editor.text.number.from",
                null,
                (option) => SurveyUtils.getReportPeriodLabel(intl, selectedProgram?.overview?.name, option)
              )}
            </FormSelect>

            <FormSelect
              className="d-inline-flex"
              value={this.state.periodEnd}
              required
              isInvalid={!this.state.periodEnd}
              onChange={(event) =>
                this.setState({periodEnd: event.target.value})
              }
            >
              {renderOptions(
                periodEndOptions,
                "survey.editor.text.number.till",
                null,
                (option) => SurveyUtils.getReportPeriodLabel(intl, selectedProgram?.overview?.name, option)
              )}
            </FormSelect>
          </FormGroup>

          <FormGroup className="mb-3">
            <FormLabel>
              <FormattedMessage id="templateList.status" /> *
            </FormLabel>
            <FormSelect
              className="d-inline-flex"
              value={this.state.status}
              required
              isInvalid={!this.state.status}
              onChange={(event) => {
                this.setState({status: event.target.value})
              }}
            >
              {renderOptions(statusOptions, "user.surveyView.dropdown.choose", "respondents.detail.status.")}
            </FormSelect>
          </FormGroup>

          <FormGroup className="mb-3">
            <FormLabel>
              <FormattedMessage id="respondents.overview.download.pdf.reports.report.type" />
            </FormLabel>
            <FormSelect
              name="reportType"
              value={this.state.reportType}
              onChange={(event) => {
                this.setState({reportType: event.target.value});
              }}
            >
              <option value={""}>
                  <FormattedMessage id="collapsible.download.downloadPdf" />
              </option>
              <option value={"AA"}>
                <FormattedMessage id="collapsible.download.downloadAAPdf" />
              </option>
              <option value={"RUECK"}>
                <FormattedMessage id="collapsible.download.downloadRueckPdf" />
              </option>
            </FormSelect>
          </FormGroup>

          <FormGroup className="mb-3">
            <FormLabel>
              <FormattedMessage id="master.data.management.project.targetRegion" />
            </FormLabel>
            <FormSelect
              name="targetRegion"
              value={this.state.targetRegion}
              onChange={(event) => {
                this.setState({targetRegion: event.target.value});
              }}
            >
              <option selected value={""}>
                <FormattedMessage id="user.surveyView.dropdown.choose" />
              </option>
              {regionsOptions.map((option) => (
                <option key={option.name} value={option.value}>
                  {option.text}
                </option>
              ))}
            </FormSelect>
          </FormGroup>

          <FormGroup  className="mb-3">
            <FormLabel>
              <FormattedMessage id="master.data.management.project.targetCountry" />
            </FormLabel>
            <FormSelect
              name="targetCountry"
              value={this.state.targetCountry}
              onChange={(event) => {
                this.setState({targetCountry: event.target.value});
              }}
            >
              <option selected value={""}>
                <FormattedMessage id="user.surveyView.dropdown.choose" />
              </option>
              {countryOptions.map((option) => (
                <option key={option.name} value={option.value}>
                  {option.text}
                </option>
              ))}
            </FormSelect>
          </FormGroup>
          <FormGroup  className="mb-3">
            <FormLabel>
              <FormattedMessage id="respondents.overview.download.pdf.reports.submission.date" />
            </FormLabel>
            <DatePickerComponent
              dateFormat="Day"
              name="dateFrom"
              value={this.state.dateFrom}
              onChange={(value) => this.setState({dateFrom: value})}
            />
            <DatePickerComponent
              dateFormat="Day"
              name="dateTo"
              value={this.state.dateTo}
              onChange={(value) => this.setState({dateTo: value})}
            />
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button
            disabled={!this.state.periodStart || !this.state.periodEnd || !this.state.status}
            onClick={this._downloadPdf}
          >
            <FormattedMessage id="respondents.detail.downloadButton" />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  _downloadPdf(){
    const { downloadSurveysPdfArchive, selectedProgram, selectedFundingArea } = this.props;
    const selectedProgramRefId = selectedProgram?.overview?.id;
    const selectedFundingAreaRefId = selectedFundingArea?.overview?.id;
    const selectedTimeFacets = this._getTimeFacets();
    const dateFrom = this.state.dateFrom ? new Date(this.state.dateFrom) : null;
    if(dateFrom) dateFrom.setUTCHours(0, 0, 0, 0);
    const dateTo = this.state.dateTo ? new Date(this.state.dateTo) : null;
    if(dateTo) dateTo.setUTCHours(23, 59, 59, 999);

    downloadSurveysPdfArchive(
      this.state.status,
      selectedTimeFacets,
      "RUECK" === this.state.reportType,
      selectedFundingAreaRefId,
      selectedProgramRefId,
      this.state.programInstance,
      null,
      this.state.location,
      this.state.targetRegion,
      this.state.targetCountry,
      dateFrom && dateFrom.getTime(),
      dateTo && dateTo.getTime()
    );
  }

  _getTimeFacets() {
    const timeFacetsArray = [];
    if (this.state.periodStart || this.state.periodEnd) {
      let timeFacets = {};
      if (this.state.periodStart) {
        timeFacets = {startTime: new Date(Date.UTC(parseInt(this.state.periodStart, 10), 0, 1, 0, 0, 0, 0)).getTime()};
      }

      if (this.state.periodEnd) {
        timeFacets = {...timeFacets, endTime: new Date(Date.UTC(parseInt(this.state.periodEnd, 10), 11, 31, 23, 59, 59, 999)).getTime()};
      }

      timeFacetsArray.push(timeFacets);
    }

    return timeFacetsArray;
  }
}

DownloadPdfReports.propTypes = {
  show: PropTypes.bool,
  close: PropTypes.func,
  template: PropTypes.object,
  externalActions: PropTypes.object,
  actions: PropTypes.object,
  step: PropTypes.bool,
  numberOfPossibleProjects: PropTypes.number,
  currentYear: PropTypes.string,
  activationActive: PropTypes.bool,
  selectedProgram: PropTypes.object,
  selectedProgramInstance: PropTypes.object,
};

export default injectIntl(DownloadPdfReports);
